import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const CloseIcon = ({ className = 'size-[24px]', color = Color.Gray700 }: NewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.41 19.41L11.71 13.12L18 19.41L19.41 18L13.12 11.71L19.41 5.41L18 4L11.71 10.29L5.41 4L4 5.41L10.29 11.71L4 18L5.41 19.41Z"
      fill={color}
    />
  </svg>
);
